import React, { useEffect, useMemo, useState } from "react";
import { ITablePagination } from "../../types/commonTypes";
import { voicebotCallListApi } from "../../store/saga/requests/voicebotRequests";
import {
  convertStringSecondsToMinutesSeconds,
  pageSizeNew,
} from "../../utils/utils";
import moment from "moment";
import { CheckCircle2, XCircle } from "lucide-react";
import { VoicebotOutcome } from "../../types/voicebotTypes";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Tooltip from "rsuite/Tooltip";
import Whisper from "rsuite/Whisper";

import "rsuite/Tooltip/styles/index.css";
import "rsuite/DateRangePicker/styles/index.css";
import "rsuite/Table/styles/index.css";
import "rsuite/Pagination/styles/index.css";

import { DateRangePicker, Input, Pagination, Table } from "rsuite";
const { Column, HeaderCell, Cell } = Table;

export default function CallListTab() {
  const initialPagination = {
    take: pageSizeNew[0],
    skip: 0,
  };

  const [callList, setCallList] = useState<VoicebotOutcome[]>([]);
  const [paginationMetaData, setPaginationMetaData] =
    useState(initialPagination);
  const [filterData, setFilterData] = useState({
    phoneNumber: "",
    policyNumber: "",
    fromDate: new Date(new Date().setDate(new Date().getDate() - 50)),
    toDate: new Date(),
  });
  const [pageCount, setPageCount] = useState<number>(1);
  const [activePage, setActivePage] = React.useState(1);
  const [selectedLog, setSelectedLog] = useState<[] | null>(null);
  const resetSelectedLog = () => setSelectedLog(null);

  // useEffect(() => {
  //   getData(paginationMetaData);
  // }, [paginationMetaData]);

  useEffect(() => {
    setPaginationMetaData(initialPagination);
    getData(initialPagination);
  }, [filterData]);

  async function getData(pageData: ITablePagination) {
    voicebotCallListApi(pageData, filterData).then((response) => {
      setCallList(response.data.data);
      setPageCount(response.data.paginationMetaData.count);
    });
  }

  const handlePageClick = (data: any) => {
    console.log("pageclick", data);
    setActivePage(data);
    const skip = (data - 1) * paginationMetaData.take;
    const newPagination: ITablePagination = {
      ...paginationMetaData,
      skip,
    };
    console.log("new Pagination: ", newPagination);
    setPaginationMetaData(newPagination);
    getData(newPagination);
  };

  const data = useMemo(() => callList, [callList]);

  const onfilterUpdate = (data: any, event: any) => {
    const newFilter = { ...filterData, [event.target.name]: data };
    setFilterData(newFilter);
  };
  const onDateChange = (data: any) => {
    const newFilter = { ...filterData, fromDate: data[0], toDate: data[1] };
    setFilterData(newFilter);
  };

  return (
    <div className=" h-[100vh]">
      {/* Filters */}
      <div className=" grid grid-cols-4	gap-2 mb-3">
        <DateRangePicker
          defaultValue={[filterData.fromDate, filterData.toDate]}
          onChange={(data) => onDateChange(data)}
          cleanable={false}
          color="black"
        />
        <Input
          size="sm"
          // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="phoneNumber"
          name="phoneNumber"
          value={filterData.phoneNumber}
          type="text"
          onChange={(e, event) => onfilterUpdate(e, event)}
          placeholder="Phone Number"
        />
        <Input
          // classNames="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="policyNumber"
          name="policyNumber"
          value={filterData.policyNumber}
          type="number"
          onChange={(e, event) => onfilterUpdate(e, event)}
          placeholder="Policy Number"
        />
      </div>
      <Dialog
        open={selectedLog != null}
        onClose={resetSelectedLog}
        className="h-[800px]"
      >
        <DialogTitle>{`Transcript`}</DialogTitle>
        <DialogContent>
          <div className="flex flex-col">
            {selectedLog !== null && selectedLog.length
              ? selectedLog.map((log: any) => (
                  <div className="my-2 border bg-gray-200 p-2">
                    {" "}
                    <span className="font-bold">{log.role}</span> -{" "}
                    {log.content}
                  </div>
                ))
              : "Invalid Log Format"}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={resetSelectedLog}>Close</Button>
        </DialogActions>
      </Dialog>

      <section className="p-2 rounded h-[70vh] bg-white flex flex-col">
        <Table virtualized fillHeight data={data}>
          <Column width={70} align="center" fixed>
            <HeaderCell>Id</HeaderCell>
            <Cell dataKey="vbOutcomeId" />
          </Column>

          <Column width={130} fixed>
            <HeaderCell>Phone Number</HeaderCell>
            <Cell dataKey="phoneNumber">
              {(rowData) => (
                <span
                  onClick={() => {
                    console.log(rowData);
                    // console.log(info.row.original.transcript);
                    setSelectedLog(
                      rowData.transcript.filter(
                        (obj: any) => obj.role !== "system"
                      ) as any
                    );
                  }}
                  className="tb-link cursor-pointer"
                >
                  {rowData.phoneNumber}
                </span>
              )}
            </Cell>
          </Column>

          <Column width={130}>
            <HeaderCell>Policy Number</HeaderCell>
            <Cell dataKey="policyNumber" />
          </Column>
          <Column width={100}>
            <HeaderCell>Call Outcome</HeaderCell>
            <Cell dataKey="outcome">
              {(rowData) => (
                <div>
                  {" "}
                  <Whisper
                    placement="top"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>{rowData.outcome}</Tooltip>}
                  >
                    <p> {rowData.outcome}</p>
                  </Whisper>
                </div>
              )}
            </Cell>
          </Column>
          <Column width={100}>
            <HeaderCell>Policy Cover</HeaderCell>
            <Cell dataKey="policyCover" />
          </Column>

          <Column width={150}>
            <HeaderCell>Annual Premium</HeaderCell>
            <Cell dataKey="annualPremium" />
          </Column>
          <Column width={100}>
            <HeaderCell>Call Duration</HeaderCell>
            <Cell dataKey="duration">
              {(rowData) => {
                return convertStringSecondsToMinutesSeconds(rowData.duration);
              }}
            </Cell>
          </Column>

          {/* <Column width={200} align="center">
            <HeaderCell>Complete Status</HeaderCell>
            <Cell dataKey="isCallCompleted">
              {({ dataKey }) => (
                <>
                  {" "}
                  {Boolean(dataKey) === true ? (
                    <CheckCircle2 color="green" />
                  ) : (
                    <XCircle color="red" />
                  )}
                </>
              )}
            </Cell>
          </Column> */}
          <Column width={200}>
            <HeaderCell>Call at</HeaderCell>
            <Cell dataKey="createdAt">
              {(rowData) => {
                return moment(rowData.createdAt).format("lll");
              }}
            </Cell>
          </Column>
          <Column width={200}>
            <HeaderCell>Status</HeaderCell>
            <Cell dataKey="status" />
          </Column>
        </Table>
        <div style={{ padding: 10 }}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="sm"
            layout={["total", "-", "limit", "|", "pager", "skip"]}
            total={pageCount}
            limitOptions={pageSizeNew}
            limit={paginationMetaData.take}
            pages={Math.ceil(pageCount / paginationMetaData.take)}
            activePage={activePage}
            onChangePage={handlePageClick}
            onChangeLimit={(e) => {
              console.log(e);
              const newPagination: ITablePagination = {
                ...paginationMetaData,
                take: Number(e),
              };
              console.log("page size: ", newPagination);
              setPaginationMetaData(newPagination);
              getData(newPagination);
            }}
          />
        </div>
      </section>
    </div>
  );
}
